export const charges = [
  {
    defendant: "2415875 Ontario LTD",
    link: "/unlicensed/B63321",
    dLocation: "Vaughan",
    oLocation: "Trent Lakes",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Acted as a builder of a new home without a licence",
  },
  {
    defendant: "2415875 Ontario LTD",
    link: "/unlicensed/B63321",
    dLocation: "Vaughan",
    oLocation: "Trent Lakes",
    chargeDate: "June 23, 2026",
    charge: "ONHWPA - Section 10.2(3) - Builder Fail to Enrol (enter into contract)",
  },
  {
    defendant: "Alla Letichever",
    link: "/unlicensed/600026117",
    dLocation: "Maple",
    oLocation: "Severn",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "Alla Letichever",
    link: "/unlicensed/600026117",
    dLocation: "Maple",
    oLocation: "North York",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "Alla Letichever",
    link: "/unlicensed/600026117",
    dLocation: "Maple",
    oLocation: "Trent Lakes",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Director of a builder of a new home without a licence",
  },
  {
    defendant: "David Letichever",
    link: "/unlicensed/600024037",
    dLocation: "Maple",
    oLocation: "Severn",
    chargeDate: "June 23, 2026",
    charge: "ONHWPA - Section 10.2(3) - Officer/Director Builder Fail to Enrol (Enter into Contract)",
  },
  {
    defendant: "David Letichever",
    link: "/unlicensed/600024037",
    dLocation: "Maple",
    oLocation: "Severn",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "David Letichever",
    link: "/unlicensed/600024037",
    dLocation: "Maple",
    oLocation: "North York",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "David Letichever",
    link: "/unlicensed/600024037",
    dLocation: "Maple",
    oLocation: "Trent Lakes",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "David Letichever",
    link: "/unlicensed/600024037",
    dLocation: "Maple",
    oLocation: "Trent Lakes",
    chargeDate: "June 23, 2026",
    charge: "ONHWPA - Section 10.2(3) - Officer/Director Builder Fail to Enrol (Enter into Contract)",
  },
  {
    defendant: "1000698258 Ontario Ltd",
    link: "/unlicensed/B64768",
    dLocation: "Maple",
    oLocation: "Severn",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Acted as a builder of a new home without a licence",
  },
  {
    defendant: "1000698258 Ontario Ltd",
    link: "/unlicensed/B64768",
    dLocation: "Maple",
    oLocation: "Severn",
    chargeDate: "June 23, 2026",
    charge: "ONHWPA - Section 10.2(3) Builder fail to Enrol (enter into contract)",
  },
  {
    defendant: "1000698258 Ontario Ltd",
    link: "/unlicensed/B64768",
    dLocation: "Maple",
    oLocation: "North York",
    chargeDate: "June 23, 2026",
    charge: "NHCLA - Section 37(2) - Acted as a builder of a new home without a licence",
  },
  {
    defendant: "Goldentrust Development Inc.",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "ONHWPA - Section 10.2(3) - Builder Fail to Enrol (enter into contract)",
  },
  {
    defendant: "Goldentrust Development Inc.",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "ONHWPA - Section 10.2(3) - Builder Fail to Enrol (enter into contract)",
  },
  {
    defendant: "Goldentrust Development Inc.",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "NHCLA-Section 37(2)-Acted as a builder of a new home without a licence",
  },
  {
    defendant: "Goldentrust Development Inc.",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "NHCLA-Section 37(2)-Acted as a builder of a new home without a licence",
  },
  {
    defendant: "Peng Zhang",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "Peng Zhang",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "NHCLA - Section 37(2) - Officer/Director of a builder of a new home without a licence",
  },
  {
    defendant: "Peng Zhang",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "ONHWPA - Section 10.2(3) - Officer/Director Builder Fail to Enrol (Enter into Contract)",
  },
  {
    defendant: "Peng Zhang",
    link: "/profile/B45662",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "May 14, 2026",
    charge: "ONHWPA - Section 10.2(3) - Officer/Director Builder Fail to Enrol (Enter into Contract)",
  },
  {
    defendant: "Sunrise Acquisitions (Stayner) Inc.",
    link: "/profile/B60689",
    dLocation: "Richmond Hill",
    oLocation: "Clearview",
    chargeDate: "October 16, 2025",
    charge: "ONHWPA - Section 10.1 - Vendor Fail to QFE/Enrol",
  },
  {
    defendant: "Sunrise Acquisitions (Stayner) Inc.",
    link: "/profile/B60689",
    dLocation: "Richmond Hill",
    oLocation: "Clearview",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Sunrise Acquisitions (Patterson) Inc.",
    link: "/profile/B60305",
    dLocation: "Richmond Hill",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge: "ONHWPA - Section 10.1 - Vendor Fail to QFE/Enrol",
  },
  {
    defendant: "Sunrise Acquisitions (Patterson) Inc.",
    link: "/profile/B60305",
    dLocation: "Richmond Hill",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Sunrise Acquisitions (Barrie) Inc.",
    link: "/profile/B48217",
    dLocation: "Richmond Hill",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
  },
  {
    defendant: "Sunrise Acquisitions (Keswick) Inc.",
    link: "/unlicensed/B64504",
    dLocation: "Richmond Hill",
    oLocation: "Georgina",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Sunrise Acquisitions (Keswick) Inc.",
    link: "/unlicensed/B64504",
    dLocation: "Richmond Hill",
    oLocation: "Georgina",
    chargeDate: "October 16, 2025",
    charge: "ONHWPA - Section 10.1 - Vendor Fail to QFE/Enrol",
  },
  {
    defendant: "Muzammil Kodwavi",
    link: "/profile/B60689",
    dLocation: "Richmond Hill",
    oLocation: "Clearview",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company that acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Muzammil Kodwavi",
    link: "/profile/B60689",
    dLocation: "Richmond Hill",
    oLocation: "Clearview",
    chargeDate: "October 16, 2025",
    charge: "ONHWPA - Section 10.1 - Officer/Director Vendor Fail to QFE/Enrol",
  },
  {
    defendant: "Muzammil Kodwavi",
    link: "/profile/B60305",
    dLocation: "Richmond Hill",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company that acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Muzammil Kodwavi",
    link: "/profile/B60305",
    dLocation: "Richmond Hill",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge: "ONHWPA - Section 10.1 - Officer/Director Vendor Fail to QFE/Enrol",
  },
  {
    defendant: "Muzammil Kodwavi",
    link: "/profile/B60305",
    dLocation: "Richmond Hill",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
  },
  {
    defendant: "Muzammil Kodwavi",
    link: "/unlicensed/B64504",
    dLocation: "Richmond Hill",
    oLocation: "Georgina",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company that acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Sajjad Hussain",
    link: "/profile/B60689",
    dLocation: "Toronto",
    oLocation: "Clearview",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company that acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Sajjad Hussain",
    link: "/profile/B60689",
    dLocation: "Toronto",
    oLocation: "Barrie",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company that acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Sajjad Hussain",
    link: "/profile/B60689",
    dLocation: "Toronto",
    oLocation: "Georgina",
    chargeDate: "October 16, 2025",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company that acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "NHCLA - Section 37(2) – Acted as a builder of a new home without a licence",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "NHCLA - Section 37(2) – Acted as a builder of a new home without a licence",
  },
  {
    defendant: "Castle Rock Homes Inc.",
    link: "/unlicensed/B43436",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(3) - Builder Fail to Enrol (enter into contract)",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director Builder fail to Enrol (shall not commence construction) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director Builder fail to Enrol (shall not commence construction) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director Builder fail to Enrol (shall not commence construction) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director Builder fail to Enrol (shall not commence construction) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director Builder fail to Enrol (shall not commence construction) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "NHCLA - Section 37(2) - Officer/Director of a Company that acted as a builder of a new home without a licence - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director Builder fail to Enrol (shall not commence construction) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "NHCLA - Section 37(2) - Officer/Director of a Company that acted as a builder of a new home without a licence - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "ONHWPA - Section 10.3 - Officer/Director Vendor or Builder failed to QFE (not constructed) - Castle Rock Homes Inc.",
  },
  {
    defendant: "Shawn Jafari",
    link: "/unlicensed/100208816",
    dLocation: "Toronto",
    oLocation: "Toronto",
    chargeDate: "August 19, 2025",
    charge:
      "Section 61(8) – Obstruct Investigator NHCLA - Castle Rock Homes Inc.",
  },
  {
    defendant: "Olga Timykoglou",
    link: "/unlicensed/B61386",
    dLocation: "Hamilton",
    oLocation: "Hamilton",
    chargeDate: "July 9, 2025",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    convictionDate: "June 18, 2026",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Olga Timykoglou",
    link: "/unlicensed/B61386",
    dLocation: "Hamilton",
    oLocation: "Hamilton",
    chargeDate: "July 9, 2025",
    charge:
      "ONHWPA - Section 10.1 - Vendor sold or offered to sell home without qualifying the home for enrolment",
    convictionDate: "June 18, 2026",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Olga Timykoglou",
    link: "/unlicensed/B61386",
    dLocation: "Hamilton",
    oLocation: "Hamilton",
    chargeDate: "July 9, 2025",
    charge:
      "-",
    convictionDate: "June 18, 2026",
    result: "Restitution order",
    fineAmount: "$500,000.00",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 69 homes - Stateview Homes (Nao Towns) Inc. ",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 12 homes - Stateview Homes (Hampton Heights) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 131 homes - Stateview Homes (Minu Towns) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 47 homes - Stateview Homes (Elia Collection) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 37(1) – Officer/Director of a Company who acted as a vendor of a new home without a licence - representing 44 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 20 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 128 homes - Stateview Homes (Elm&Co) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 2 homes - Stateview Homes (On the Mark) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 69 homes - Stateview Homes (Nao Towns) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 12 homes - Stateview Homes (Hampton Heights) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 131 homes - Stateview Homes (Minu Towns) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 47 homes - Stateview Homes (Elia Collection) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 44 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 20 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 128 homes - Stateview Homes (Elm&Co) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence- representing 2 homes - Stateview Homes (On the Mark) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 69 homes - Stateview Homes (Nao Towns) Inc. ",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 12 homes - Stateview Homes (Hampton Heights) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 131 homes - Stateview Homes (Minu Towns) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 47 homes - Stateview Homes (Elia Collection) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 37(1) – Officer/Director of a Company who acted as a vendor of a new home without a licence - representing 44 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 20 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 128 homes - Stateview Homes (Elm&Co) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 2 homes - Stateview Homes (On the Mark) Inc.",
  },
  {
    defendant: "Stateview Homes (On The Mark) Inc.",
    link: "/profile/B48325",
    dLocation: "Woodbridge ON",
    oLocation: "Markham ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 2 homes",
  },
  {
    defendant: "Stateview Homes (Queen's Court) Inc.",
    link: "/profile/B61656",
    dLocation: "Woodbridge ON",
    oLocation: "Brampton ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 37(1) – Acted as a vendor of a new home without a licence - representing 44 homes",
  },
  {
    defendant: "Stateview Homes (Queen's Court) Inc.",
    link: "/profile/B61656",
    dLocation: "Woodbridge ON",
    oLocation: "Brampton ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 20 homes",
  },
  {
    defendant: "Stateview Homes (Elia Collection) Inc.",
    link: "/profile/B61334",
    dLocation: "Woodbridge ON",
    oLocation: "Newmarket ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 47 homes",
  },
  {
    defendant: "Stateview Homes (Elm&Co) Inc.",
    link: "/profile/B61469",
    dLocation: "Woodbridge ON",
    oLocation: "Whitchurch- Stouffville ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 128 homes",
  },
  {
    defendant: "Stateview Homes (Minu Towns) Inc.",
    link: "/profile/B60578",
    dLocation: "Woodbridge ON",
    oLocation: "Markham ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 131 homes",
  },
  {
    defendant: "Stateview Homes (Hampton Heights) Inc.",
    link: "/profile/B60363",
    dLocation: "Woodbridge ON",
    oLocation: "Barrie ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 12 homes",
  },
  {
    defendant: "Stateview Homes (Nao Towns) Inc.",
    link: "/profile/B48820",
    dLocation: "Woodbridge ON",
    oLocation: "Markham ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 69 homes",
  },
  {
    defendant: "Shaheda Karim Jesmin",
    link: "/unlicensed/B63487",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "November 4, 2024",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    convictionDate: "September 25, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "MA Karim Belal Kazi",
    link: "/unlicensed/B64340",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "November 4, 2024",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    convictionDate: "September 25, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Mashiat Mutmainnah",
    link: "/unlicensed/B63488",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    fineAmount: "$9,375.00",
    convictionDate: "May 16, 2025",
    result: "Convicted Fine",
  },
  {
    defendant: "Shaheda Karim Jesmin",
    link: "/unlicensed/B63487",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "September 25, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with condition of licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with condition of licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(2) - Acted as a builder of a new home without a licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 10.2(4) - Officer/Director of a Company who commenced construction and failed to receive enrolment confirmation",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$4,687.50",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$4,687.50",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$4,687.50",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$9,375.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$4,687.50",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$4,687.50",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 71(1)(b) - Officer/Director of a Company who Fails to comply with Condition of Licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Zamal Hossain",
    link: "/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(2) -Officer/Director of a Company who acted as a builder of a new home without a licence",
    convictionDate: "November 13, 2025",
    result: "Convicted Fine",
    fineAmount: "$4,687.50",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
    convictionDate: "April 14, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "April 14, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "Section 37(2) – Acted as a builder of a new home without a licence",
    convictionDate: "April 14, 2025",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 10.2(3) - Builder entered into a contract and failed to receive enrolment confirmation",
    convictionDate: "April 14, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "James Lischkoff",
    link: "/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company that Illegally acted as a Builder of a New Home",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company that Failed to Enrol a New Home",
    result: "Suspended Sentence",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "NHCLA - Section 37(2) - Officer/Director of a Company that acted as a builder of a new home without a licence",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 10.2(3)- Officer/Director of a Company that entered into a contract and failed to receive enrolment confirmation",
    result: "Suspended Sentence",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "",
    result: "Restitution Order",
    fineAmount: "$130,000.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "",
    result: "Restitution Order",
    fineAmount: "$25,000.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "Exquisite Bay Development Inc.",
    link: "/profile/B44757",
    dLocation: "Mississauga, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    convictionDate: "June 19, 2026",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Exquisite Bay Development Inc.",
    link: "/profile/B44757",
    dLocation: "Mississauga, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    convictionDate: "June 19, 2026",
    result: "Convicted Fine",
    fineAmount: "$6,250.00",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "/profile/B44757",
    dLocation: "Oakville, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "NHCLA - Section 37(1) – Officer/Director of a vendor of a new home without a licence",
    convictionDate: "June 19, 2026",
    result: "Convicted Fine",
    fineAmount: "$3,125.00",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "/profile/B44757",
    dLocation: "Oakville, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "NHCLA - Section 37(1) – Officer/Director of a vendor of a new home without a licence",
    convictionDate: "June 19, 2026",
    result: "Convicted Fine",
    fineAmount: "$3,125.00",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "/profile/B44757",
    dLocation: "Oakville, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "June 19, 2026",
    result: "Restitution Order",
    fineAmount: "$100,000.00",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "/profile/B44757",
    dLocation: "Oakville, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "-",
    convictionDate: "June 19, 2026",
    result: "Restitution Order",
    fineAmount: "$100,000.00",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "/profile/B44757",
    dLocation: "Oakville, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "-",
    convictionDate: "June 19, 2026",
    result: "Restitution Order",
    fineAmount: "$15,000.00",
  },
  // {
  //   defendant: "Matoma Corporation",
  //   link: "/unlicensed/B46630",
  //   dLocation: "Barrie, ON",
  //   oLocation: "Mississauga, ON",
  //   chargeDate: "October 31, 2017",
  //   charge: "ONHWPA - Sec 6 - Illegally acted as a Builder of a New Home",
  //   convictionDate: "November 13, 2018",
  //   result: "Convicted Fine",
  //   fineAmount: "$6,250.00",
  // },
  // {
  //   defendant: "Matoma Corporation",
  //   link: "/unlicensed/B46630",
  //   dLocation: "Barrie, ON",
  //   oLocation: "Mississauga, ON",
  //   chargeDate: "October 31, 2017",
  //   charge: "ONHWPA - Sec 12 - Failed to Enrol a New Home",
  //   convictionDate: "November 13, 2018",
  //   result: "Convicted Suspended Sentence",
  // },
  {
    defendant: "Matoma Corporation",
    link: "/unlicensed/B46630",
    dLocation: "Barrie, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
    convictionDate: "October 16, 2025",
    result: "Convicted Fine",
    fineAmount: "$45,000",
  },
  {
    defendant: "Matoma Corporation",
    link: "/unlicensed/B46630",
    dLocation: "Barrie, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "October 16, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Tomas Joseph Pavlovic",
    link: "/unlicensed/100466551",
    dLocation: "Mississauga, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home",
    convictionDate: "October 16, 2025",
    result: "Convicted Fine",
    fineAmount: "$25,000",
  },
  {
    defendant: "Tomas Joseph Pavlovic",
    link: "/unlicensed/100466551",
    dLocation: "Mississauga, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
    convictionDate: "October 16, 2025",
    result: "Suspended Sentence",
  },
  // {
  //   defendant: "Tomas Joseph Pavlovic",
  //   link: "/unlicensed/100466551",
  //   dLocation: "Mississauga, ON",
  //   oLocation: "The Blue Mountains, ON",
  //   chargeDate: "October 31, 2017",
  //   charge:
  //     "ONHWPA - Sec 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home",
  //   convictionDate: "November 13, 2018",
  //   result: "Convicted Suspended Sentence",
  // },
  // {
  //   defendant: "Tomas Joseph Pavlovic",
  //   link: "/unlicensed/100466551",
  //   dLocation: "Mississauga, ON",
  //   oLocation: "The Blue Mountains, ON",
  //   chargeDate: "October 31, 2017",
  //   charge:
  //     "ONHWPA - Sec 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  //   convictionDate: "November 13, 2018",
  //   result: "Convicted Suspended Sentence",
  // },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge:
      "NHCLA-Section 37(2)-Acted as a builder of a new home without a licence",
    convictionDate: "December 19, 2024",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge:
      "NHCLA-Section 37(2)-Held oneself out as a builder of a new home without a licence",
    convictionDate: "December 19, 2024",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge: "NHCLA-Section 71(1)(c)-Failed to comply with an order",
    convictionDate: "December 19, 2024",
    result: "Convicted Fine",
    fineAmount: "$31,250.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge: "",
    convictionDate: "December 19, 2024",
    result: "Restitution Order",
    fineAmount: "$154,122.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge: "",
    convictionDate: "December 19, 2024",
    result: "Restitution Order",
    fineAmount: "$40,000.00",
  },
  {
    defendant: "Nasrin Jahan",
    link: "/unlicensed/600012296",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "February 1, 2023",
    charge: "ONHWPA - Sec 6 - Illegally acted as a vendor of a new home",
    convictionDate: "September 8, 2023",
    result: "Convicted Suspended Sentence",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "1970175 Ontario Inc.",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$11.00",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Christopher Lamb (currently Christopher Adams)",
    link: "/profile/B47828",
    dLocation: "Niagara Falls",
    oLocation: "St. Catharines",
    chargeDate: "November 8, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    convictionDate: "December 4, 2023",
    result: "Convicted Fine",
    fineAmount: "$5,769.23",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Withdrawn",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a New Home",
    convictionDate: "September 15, 2023",
    result: "Convicted Fine",
    fineAmount: "$15,625.00",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge:
      "NHCLA - Section 61 - Fail to produce evidence described in a warrant",
    convictionDate: "September 15, 2023",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Ideal (BC) Developments Inc.",
    link: "/unlicensed/B48282",
    dLocation: "Markham",
    oLocation: "Richmond Hill",
    chargeDate: "August 4, 2021",
    charge: "",
    convictionDate: "September 15, 2023",
    result: "Restitution Order",
    fineAmount: "$150,000.00",
  },
  {
    defendant: "Syed Nasir Ali Shah",
    link: "/profile/B44757",
    dLocation: "Bolton, ON",
    oLocation: "Simcoe, ON",
    chargeDate: "July 5, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
    result: "Withdrawn",
    convictionDate: "September 15, 2023",
  },
  {
    defendant: "2252759 Ontario Inc.",
    link: "/profile/B44757",
    dLocation: "Mississauga",
    oLocation: "Simcoe",
    chargeDate: "July 5, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
    result: "Convicted Fine",
    convictionDate: "September 15, 2023",
    fineAmount: "$12,500.00",
  },
  {
    defendant: "Mike Rosen Homes Inc",
    link: "/unlicensed/B48895",
    dLocation: "Maple",
    oLocation: "Toronto",
    chargeDate: "July 5, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
    result: "Convicted Fine",
    convictionDate: "February 24, 2023",
    fineAmount: "$3,125.00",
  },
  {
    defendant: "Mike Rosen Homes Inc",
    link: "/unlicensed/B48895",
    dLocation: "Maple",
    oLocation: "Toronto",
    chargeDate: "July 5, 2021",
    charge: "ONHWPA - Sec 12 - Failed to Enrol a New Home",
    result: "Suspended sentence",
    convictionDate: "February 24, 2023",
  },
  {
    defendant: "Mikhael Rozenblit",
    link: "/unlicensed/B48895",
    dLocation: "Maple",
    oLocation: "Toronto",
    chargeDate: "July 5, 2021",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
    result: "Convicted Fine",
    convictionDate: "February 24, 2023",
    fineAmount: "$3,125.00",
  },
  {
    defendant: "Mikhael Rozenblit",
    link: "/unlicensed/B48895",
    dLocation: "Maple",
    oLocation: "Toronto",
    chargeDate: "July 5, 2021",
    charge: "ONHWPA - Sec 12 - Failed to Enrol a New Home",
    result: "Suspended sentence",
    convictionDate: "February 24, 2023",
  },
];
